import { useContext } from 'react'
import { GroupDataContext } from '../providers/GroupDataProvider'

export default function useGroupData() {
  const context = useContext(GroupDataContext)

  // Ensure that the context is not undefined. This will throw an error if useGroupData is used outside of GroupDataProvider
  if (!context) {
    throw new Error('useGroupData must be used within a GroupDataProvider')
  }
  return context
}
